module.exports = __webpack_public_path__ + "static/stork-otc-box-8edac790953b550ff0d5d3c46ccaa81b.jpg";